import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext.js";
import { uploadAPI } from "../services/api";

export function Login() {
  const { login, forgotPassword } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotMsg, setForgotMsg] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);

  const handle = async () => {
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.role === "admin" ? "/admin" : "/");
    } catch(e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleForgot = async () => {
    if (!forgotEmail.trim()) return;
    setForgotLoading(true);
    setForgotMsg("");
    try {
      const message = await forgotPassword(forgotEmail.trim());
      setForgotMsg(message);
    } catch(e) {
      setForgotMsg(e.message);
    } finally {
      setForgotLoading(false);
    }
  };

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.logo}>יד לָיָד • Yad2Yad</div>
        <h2 style={s.title}>Ingresar</h2>
        <label style={s.label}>Email</label>
        <input style={s.input} type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="tu@email.com" />
        <label style={s.label}>Contrasena</label>
        <input style={s.input} type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="••••••••" onKeyDown={e=>e.key==="Enter"&&handle()} />
        {error && <p style={s.error}>{error}</p>}
        <button style={{...s.btn,opacity:loading?0.7:1}} onClick={handle} disabled={loading}>
          {loading?"Ingresando...":"Ingresar"}
        </button>

        {!showForgot ? (
          <p style={s.hint}>
            <span style={{...s.link,cursor:"pointer"}} onClick={() => setShowForgot(true)}>¿Olvidaste tu contraseña?</span>
          </p>
        ) : (
          <div style={{marginTop:16,textAlign:"left"}}>
            <label style={s.label}>Tu email</label>
            <input style={s.input} type="email" value={forgotEmail} onChange={e=>setForgotEmail(e.target.value)} placeholder="tu@email.com" />
            <button style={{...s.btn,opacity:forgotLoading?0.7:1}} onClick={handleForgot} disabled={forgotLoading}>
              {forgotLoading?"Enviando...":"Recuperar contraseña"}
            </button>
            {forgotMsg && <p style={{fontSize:13,color:"#555",marginTop:10,lineHeight:1.5}}>{forgotMsg}</p>}
          </div>
        )}

        <p style={s.hint}>No tenes cuenta? <Link to="/register" style={s.link}>Registrate</Link></p>
      </div>
    </div>
  );
}


export function Register() {
  const { register } = useApp();
  const [form, setForm] = useState({
    firstName:"", lastName:"", email:"", password:"",
    inviteCode:"", community:"", rabbi:"", dni:"",
  });
  const [dniPhotoFile, setDniPhotoFile] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const set = (key, val) => setForm(f => ({...f, [key]:val}));

  const handle = async () => {
    setError("");
    if (!form.firstName.trim())   { setError("El nombre es obligatorio"); return; }
    if (!form.lastName.trim())    { setError("El apellido es obligatorio"); return; }
    if (!form.email.trim())       { setError("El email es obligatorio"); return; }
    if (!form.email.includes("@")) {
      
  setError("El email debe ser válido (debe contener @)");
  return;
}
    if (form.password.length < 6) { setError("La contrasena debe tener al menos 6 caracteres"); return; }
    if (!form.inviteCode.trim())  { setError("El codigo de invitacion es obligatorio"); return; }
    if (!form.community.trim())   { setError("La comunidad es obligatoria"); return; }
    if (!form.rabbi.trim())       { setError("El nombre del rabino es obligatorio"); return; }
    if (!form.dni.trim())         { setError("El DNI es obligatorio"); return; }
    if (!dniPhotoFile)            { setError("Subi una foto de tu DNI"); return; }

    setLoading(true);
    try {
      const { userId } = await register(
        `${form.firstName.trim()} ${form.lastName.trim()}`,
        form.email, form.password, form.inviteCode,
        form.community, form.rabbi, form.dni.trim()
      );
      await uploadAPI.uploadDniPhoto(dniPhotoFile, userId);
      setSuccess(true);
    } catch(e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div style={s.wrap}>
        <div style={s.card}>
          <div style={{fontSize:56,textAlign:"center",marginBottom:16}}>✅</div>
          <h2 style={{...s.title,fontSize:20}}>Solicitud enviada!</h2>
          <div style={s.pendingBox}>
            <p style={s.pendingTitle}>🎉 ¡Registro completado!</p>
            <p style={s.pendingText}>Tu solicitud ya está esperando la aprobación de la administración. Cuando intentes ingresar te vamos a avisar si tu cuenta fue aprobada o no.</p>
          
          </div>
          
          <Link to="/login" style={s.btn2}>Volver al inicio</Link>
        </div>

      </div>
    );
  }

  return (
    <div style={s.wrap}>
      <div style={{...s.card, maxWidth:480}}>
        <div style={s.logo}>יד לָיָד • Yad2Yad</div>
        <h2 style={s.title}>Solicitar registro</h2>

        <div style={s.infoBox}>
          <p style={s.infoText}>🔐 Plataforma exclusiva para miembros de la comunidad. Necesitas un codigo de invitacion.</p>
        </div>

        <label style={s.label}>Codigo de invitacion *</label>
        <input style={{...s.input,fontWeight:600,letterSpacing:2,textTransform:"uppercase"}} value={form.inviteCode} onChange={e=>set("inviteCode",e.target.value.toUpperCase())} placeholder="Ej: YAD2024" />

        <div style={s.row2}>
          <div style={{flex:1}}>
            <label style={s.label}>Nombre *</label>
            <input style={s.input} value={form.firstName} onChange={e=>set("firstName",e.target.value)} placeholder="Maria" />
          </div>
          <div style={{flex:1}}>
            <label style={s.label}>Apellido *</label>
            <input style={s.input} value={form.lastName} onChange={e=>set("lastName",e.target.value)} placeholder="Garcia" />
          </div>
        </div>

        <label style={s.label}>Email *</label>
        <input style={s.input} type="email" value={form.email} onChange={e=>set("email",e.target.value)} placeholder="tu@email.com" />

        <label style={s.label}>Contrasena *</label>
        <input style={s.input} type="password" value={form.password} onChange={e=>set("password",e.target.value)} placeholder="Minimo 6 caracteres" />

        <div style={s.communitySection}>
          <p style={s.communityTitle}>🕍 Informacion de comunidad</p>
          <label style={s.label}>A que comunidad perteneces? *</label>
          <input style={s.input} value={form.community} onChange={e=>set("community",e.target.value)}  />
          <label style={s.label}>Nombre del rabino de tu comunidad *</label>
          <input style={s.input} value={form.rabbi} onChange={e=>set("rabbi",e.target.value)}  />
        </div>

        <label style={s.label}>DNI *</label>
        <input style={s.input} type="tel" inputMode="numeric" value={form.dni} onChange={e=>set("dni",e.target.value.replace(/\D/g,""))} placeholder="Ej: 30123456" />

        <label style={s.label}>Foto de tu DNI (frente) *</label>
        <input style={s.input} type="file" accept="image/*" onChange={e=>setDniPhotoFile(e.target.files?.[0] || null)} />
        {dniPhotoFile && <p style={s.hint}>Seleccionaste: {dniPhotoFile.name}</p>}
        <p style={{fontSize:12,color:"#888",lineHeight:1.5,marginBottom:16}}>
          🔒 Esta foto es <strong>privada y confidencial</strong>: solo la pueden ver los administradores, para verificar tu identidad.
        </p>

        {error && <p style={s.error}>{error}</p>}

        <button style={{...s.btn,opacity:loading?0.7:1}} onClick={handle} disabled={loading}>
          {loading?"Enviando solicitud...":"Solicitar registro"}
        </button>
        <p style={s.hint}>Ya tenes cuenta? <Link to="/login" style={s.link}>Ingresar</Link></p>
      </div>
    </div>
  );
}

const s = {
  wrap:{minHeight:"calc(100vh - 68px)",background:"#f5f5f5",display:"flex",alignItems:"center",justifyContent:"center",padding:20},
  card:{background:"#fff",borderRadius:16,padding:"36px 32px",width:"100%",maxWidth:420,boxShadow:"0 2px 16px rgba(0,0,0,0.06)"},
  logo:{fontSize:18,fontWeight:700,textAlign:"center",marginBottom:20,color:"#1D9E75"},
  title:{fontSize:22,fontWeight:600,marginBottom:20,textAlign:"center"},
  infoBox:{background:"#f0faf6",border:"0.5px solid #b0dcc9",borderRadius:10,padding:"12px 14px",marginBottom:20},
  infoText:{fontSize:13,color:"#0F6E56",lineHeight:1.5},
  row2:{display:"flex",gap:12},
  label:{display:"block",fontSize:13,color:"#555",marginBottom:5,fontWeight:500},
  input:{width:"100%",padding:"10px 12px",borderRadius:8,border:"0.5px solid #ddd",fontSize:14,marginBottom:14},
  communitySection:{background:"#f9f9f9",borderRadius:10,padding:"16px",marginBottom:14,border:"0.5px solid #e0e0e0"},
  communityTitle:{fontSize:14,fontWeight:600,color:"#333",marginBottom:14},
  btn:{display:"block",width:"100%",background:"#1D9E75",color:"#fff",border:"none",borderRadius:10,padding:13,fontSize:15,fontWeight:500,cursor:"pointer",marginTop:4,textAlign:"center",textDecoration:"none"},
  btn2:{display:"block",textAlign:"center",background:"#f0faf6",color:"#1D9E75",border:"0.5px solid #b0dcc9",borderRadius:10,padding:13,fontSize:15,fontWeight:500,textDecoration:"none",marginTop:16},
  error:{color:"#E24B4A",fontSize:13,marginBottom:10},
  hint:{textAlign:"center",fontSize:13,color:"#777",marginTop:14},
  link:{color:"#1D9E75",fontWeight:500,textDecoration:"none"},
  pendingBox:{background:"#fff8e1",border:"0.5px solid #f0c040",borderRadius:10,padding:"16px",marginBottom:20},
  pendingTitle:{fontSize:15,fontWeight:600,color:"#b7830a",marginBottom:8},
  pendingText:{fontSize:13,color:"#666",lineHeight:1.6},
};
